<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '420px' }"
  [styleClass]="'actions-summary-dialog'">

  <div class="flex flex-col gap-2">
    <h3 class="m-0 text-base font-semibold" style="color: var(--p-text-color)">Actions Summary</h3>

    @if (infoMessage()) {
      <p class="m-0 text-sm font-medium" style="color: var(--p-primary-color)">{{ infoMessage() }}</p>
    }

    @if (data(); as d) {
      <p class="m-0 text-sm font-semibold px-2 py-1 rounded border-l-4"
         style="background: var(--p-surface-100); border-color: var(--p-primary-color); color: var(--p-text-color)">
        {{ countMessage() }}
      </p>

      @if (d.successActions.length > 0) {
        <div>
          <p class="m-0 mb-1 text-sm font-bold" style="color: var(--p-green-600)">Success:</p>
          <ul class="list-none p-0 m-0 flex flex-col gap-1">
            @for (action of d.successActions; track action) {
              <li class="flex items-center gap-2 text-sm" style="color: var(--p-text-color)">
                <i class="pi pi-check-circle text-sm" style="color: var(--p-green-600)"></i>
                <span>{{ action }}</span>
              </li>
            }
          </ul>
        </div>
      }

      @if (d.failedActions.length > 0) {
        <div>
          <p class="m-0 mb-1 text-sm font-bold" style="color: var(--p-red-600)">Failed:</p>
          <ul class="list-none p-0 m-0 flex flex-col gap-1">
            @for (action of d.failedActions; track action) {
              <li class="flex items-start gap-2 text-sm">
                <i class="pi pi-times-circle text-sm mt-0.5 flex-shrink-0" style="color: var(--p-red-600)"></i>
                <div class="flex flex-col gap-1">
                  <span class="font-semibold" style="color: var(--p-text-color)">{{ action }}</span>
                  @if (getErrorDetail(action)) {
                    <div class="text-xs px-2 py-1 rounded" style="background: var(--p-red-50); color: var(--p-red-800)">
                      <strong class="block" style="color: var(--p-red-700)">Error:</strong>
                      {{ getErrorDetail(action) }}
                    </div>
                  }
                </div>
              </li>
            }
          </ul>
        </div>
      }
    }
  </div>

  <ng-template pTemplate="footer">
    <p-button [label]="buttonLabel()" (click)="onClose()" [autofocus]="true" size="small" />
  </ng-template>
</p-dialog>
